import { t } from '@lingui/core/macro';
import { Box } from '@mui/material';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import * as React from 'react';

import { SecondSidebar } from '@/app/NewNavigation/NewNavigationShell';
import { NegotiationSidebar } from '@/areas/negotiations/Negotiations/components/NegotiationSidebar';
import type { PageStaticData } from '@/shared/routing';
import { ErrorBoundaryClearedOnNavigation } from '@/shared/ui/errors/ErrorBoundaryClearedOnNavigation';
import { SidebarRouteLayout } from '@/shared/ui/PageLayoutCollapsibleSidebar';

// The pages beside the negotiation's sidebar, a second one beside the app's; the solution manager stays outside this group.
export const Route = createFileRoute('/_authenticated/next/negotiations/$negotiationId/_sidebar')({
    // Each page checks who may open it.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

const SidebarPlaceholder = (): JSX.Element => <Box sx={{ width: 240 }} />;

function RouteComponent(): JSX.Element {
    const { negotiationId } = Route.useParams();
    return (
        <>
            <SecondSidebar>
                <nav aria-label={t`Negotiation`} style={{ display: 'flex' }}>
                    {/* The page beside shows its own error; the sidebar keeps its width meanwhile. */}
                    <ErrorBoundaryClearedOnNavigation fallback={SidebarPlaceholder}>
                        <React.Suspense fallback={<SidebarPlaceholder />}>
                            <NegotiationSidebar negotiationId={negotiationId} />
                        </React.Suspense>
                    </ErrorBoundaryClearedOnNavigation>
                </nav>
            </SecondSidebar>
            {/* The pages' row and scroll area in the panel, as beside today's sidebar. */}
            <SidebarRouteLayout sidebar={null}>
                <Outlet />
            </SidebarRouteLayout>
        </>
    );
}
